import { api, apiEndPoints } from "../../api/index";

export const getContentModerationData = (params) =>
  api.get(apiEndPoints.getContentModerations, { params: { params } });
